import axios from 'axios';

function state() {
    return {
        user: {},
        project: {}
    };
}

const mutations = {
    setUser(state, user) {
        state.user = user;
    },
    setProject(state, project) {
        state.project = project;
    },
};

const actions = {
    async getUser({ commit }) {
        try {
            const { data } = await axios.get('/user');
            commit('setUser', data);
            return data;
        } catch (e) {
            return {};
        }
    }
};

const getters = {
    user: (state) => state.user,
    isAdmin: (state) => state.user?.is_admin,
    isLoggedIn: (state) => Object.keys(state.user).length !== 0,
    project: (state) => state.project,
    hasProject: (state) => Object.keys(state.project).length !== 0,
};

export default {
    state,
    getters,
    mutations,
    actions,
    namespaced: true,
};
